<script setup>
// PublicDeviceCheck — the signed-out device check. The "Test microphone" button
// on PublicHome used to point at /settings, which is requiresAuth, so an
// anonymous visitor got bounced to /login before they could confirm their mic
// worked — the exact opposite of the "no account needed to begin" promise.
//
// This is a thin storefront wrapper (constrained container + heading + a way
// back) around the SAME SettingsDevice component the signed-in /settings page
// renders. SettingsDevice depends only on the framework-agnostic
// composables/useSystemCheck.js (getUserMedia + WebAudio + UA sniffing) — no
// auth, no shell — so it runs unauthenticated with no change. Reusing it means
// the anonymous check and the signed-in check can never drift apart.
import SettingsDevice from "../settings/SettingsDevice.vue";
</script>

<template>
  <section class="dc">
    <header class="dc-head">
      <h1>Test your microphone</h1>
      <p class="dc-lead">
        Check your speakers and microphone before you start — no account needed.
        i-Recall reads each question aloud and listens for your spoken answer, so
        working audio in and out is all you need.
      </p>
    </header>

    <SettingsDevice />

    <p class="dc-cta">
      <router-link to="/" class="dc-back"><i class="bi bi-arrow-left me-1"></i>Browse the topics</router-link>
    </p>
  </section>
</template>

<style scoped>
/* Clearance under the overlaid header is handled centrally by PublicLayout
   (.pub-main.no-hero). This wraps the reused device-check cards in a reading
   column (wider than PublicPage's prose — the cards need the room). */
.dc { max-width: 860px; margin: 0 auto; padding: 3.5rem 1.25rem 1rem; }
.dc-head { padding-bottom: 1.75rem; margin-bottom: 2rem; border-bottom: 1px solid #e8edf5; }
.dc h1 { margin: 0; font-size: clamp(2rem, 4vw, 2.75rem); font-weight: 800; letter-spacing: -.02em; color: #0f172a; }
.dc-lead { margin: .9rem 0 0; font-size: 1.1rem; line-height: 1.5; color: #475569; }
.dc-cta { margin: 2.5rem 0 0; }
.dc-back { color: #2563eb; font-weight: 600; text-decoration: none; }
.dc-back:hover { text-decoration: underline; }
</style>
